export default __webpack_public_path__ + "media/images/icon_cached-e30003d3cc5c1ac2e678be644c029a33.svg";